import { createStore } from 'vuex'
import cambioImagenes from './modulos/functions'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    cambioImagenes
  }
})
